import { GateLocation } from './OurGateTypes';

export function parseGateLocation(latitude: string, longitude: string, radius: string): GateLocation {
  if (!latitude.trim() || !longitude.trim() || !radius.trim()) {
    throw new Error('Enter latitude, longitude, and radius, or use Remove location.');
  }
  const value = { latitude: Number(latitude), longitude: Number(longitude), radiusMeters: Number(radius) };
  if (!Number.isFinite(value.latitude) || Math.abs(value.latitude) > 90) throw new Error('Latitude must be between -90 and 90.');
  if (!Number.isFinite(value.longitude) || Math.abs(value.longitude) > 180) throw new Error('Longitude must be between -180 and 180.');
  if (!Number.isFinite(value.radiusMeters) || value.radiusMeters < 100 || value.radiusMeters > 1000) throw new Error('Radius must be between 100 and 1,000 meters.');
  return value;
}
